
// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import Tabs from 'react-bootstrap/Tabs';
// import Tab from 'react-bootstrap/Tab';
// import Modal from 'react-bootstrap/Modal';

// const VisaMasterDetails = () => {
//   const { id } = useParams();
//   const { user } = useAuth();
//   const navigate = useNavigate();
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // --- POPUP STATE FOR PRICING ---
//   const [showPriceModal, setShowPriceModal] = useState(false);
//   const [activeVisaIdx, setActiveVisaIdx] = useState(null);
//   const [priceCategory, setPriceCategory] = useState(""); // "B2B" or "B2C"

//   useEffect(() => {
//     const fetchDetails = async () => {
//       const res = await apiService.get(`${config.GET_VISA_BY_ID}/${id}`);
//       setData(res);
//       setLoading(false);
//     };
//     fetchDetails();
//   }, [id]);

//   const handleUpdate = async () => {
//   const res = await apiService.update(config.UPDATE_VISA_MASTER, data);
//   if (res) alert("Data Updated Successfully!");
// };

//   // --- VISAS LOGIC ---
//   const handleAddVisa = () => {
//     const newVisa = {
//       visaId: "00000000-0000-0000-0000-000000000000",
//       visaName: "",
//       visaUrl: "",
//       countryUrl: data.countryUrl,
//       visaType: "TOURIST",
//       processingTime: 5,
//       stayPeriod: "30 Days",
//       validity: "90 Days",
//       entry: "SINGLE",
//       visaCountryId: data.visaCountryId,
//       visaCountryName: data.name,
//       // Initialize nested price list for the new visa
//       visaPrices: [
//         { adultPrice: 0, childPrice: 0, serviceFee: 0, priceType: "B2B" },
//         { adultPrice: 0, childPrice: 0, serviceFee: 0, priceType: "B2C" }
//       ],
//       isActive: true,
//       b2CStatus: false,
//       b2BStatus: true,
//       apiStatus: false
//     };
//     setData({ ...data, visas: [newVisa, ...data.visas] });
//   };

//   const removeVisa = (index) => {
//     const newVisas = [...data.visas];
//     newVisas.splice(index, 1);
//     setData({ ...data, visas: newVisas });
//   };

//   // --- PRICE POPUP LOGIC ---
//   const handleOpenPriceModal = (index, category) => {
//     const visa = data.visas[index];
    
//     // Safety check to ensure visaPrices array and objects exist
//     if (!visa.visaPrices) visa.visaPrices = [];
//     if (!visa.visaPrices.find(p => p.priceType === category)) {
//         visa.visaPrices.push({ adultPrice: 0, childPrice: 0, serviceFee: 0, priceType: category });
//     }

//     setActiveVisaIdx(index);
//     setPriceCategory(category);
//     setShowPriceModal(true);
//   };

//   const handlePriceChange = (field, value) => {
//     const newVisas = [...data.visas];
//     const visa = newVisas[activeVisaIdx];
//     const priceObj = visa.visaPrices.find(p => p.priceType === priceCategory);
    
//     if (priceObj) {
//         priceObj[field] = parseFloat(value) || 0;
//         setData({ ...data, visas: newVisas });
//     }
//   };

//   // --- DOCUMENTS LOGIC ---
//   const handleAddDocument = () => {
//     const newDoc = {
//       visaDocumentId: null,
//       visaCountryId: data.visaCountryId,
//       visaType: "TOURIST",
//       documentName: "",
//       visaCountryName: data.name
//     };
//     setData({ ...data, visaDocuments: [...data.visaDocuments, newDoc] });
//   };

//   const removeDocument = (index) => {
//     const newDocs = [...data.visaDocuments];
//     newDocs.splice(index, 1);
//     setData({ ...data, visaDocuments: newDocs });
//   };

//   // --- TERMS LOGIC ---
//   const handleAddTerm = () => {
//     const newTerm = {
//       visaTermsId: null,
//       visaCountryId: data.visaCountryId,
//       termsandConditions: "",
//       visaCountryName: data.name
//     };
//     setData({ ...data, visaTerms: [...data.visaTerms, newTerm] });
//   };

//   const removeTerm = (index) => {
//     const newTerms = [...data.visaTerms];
//     newTerms.splice(index, 1);
//     setData({ ...data, visaTerms: newTerms });
//   };

//   // --- FAQ LOGIC ---
//   const handleAddFAQ = () => {
//     const newFAQ = {
//       visaFAQId: null,
//       visaCountryId: data.visaCountryId,
//       question: "",
//       answer: "",
//       visaCountryName: data.name
//     };
//     setData({ ...data, visaFAQs: [newFAQ, ...data.visaFAQs] });
//   };

//   const removeFAQ = (index) => {
//     const newFAQs = [...data.visaFAQs];
//     newFAQs.splice(index, 1);
//     setData({ ...data, visaFAQs: newFAQs });
//   };

//   if (loading) return <div className="p-5 text-center"><h4>Loading Visa Details...</h4></div>;

//   return (
//     <div id="layout-wrapper">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="row">
//               <div className="col-12">
//                 <div className="card">
//                   <div className="card-header d-flex justify-content-between align-items-center">
//                     <h4 className="card-title mb-0">Manage {data.name}</h4>
//                     <button className="btn btn-success" onClick={handleUpdate}>
//                       <i className="ri-save-line align-bottom me-1"></i> Save Changes
//                     </button>
//                   </div>
//                   <div className="card-body">
//                     <Tabs defaultActiveKey="general" className="nav-tabs-custom">

//                       {/* 1. GENERAL INFO */}
//                       <Tab eventKey="general" title="General Info">
//                         <div className="row mt-4">
//                           <div className="col-md-4 mb-3">
//                             <label className="form-label">Country Name</label>
//                             <input className="form-control" value={data.name || ""} onChange={(e) => setData({ ...data, name: e.target.value })} />
//                           </div>
//                           <div className="col-md-4 mb-3">
//                             <label className="form-label">Country URL</label>
//                             <input className="form-control" value={data.countryUrl || ""} onChange={(e) => setData({ ...data, countryUrl: e.target.value })} />
//                           </div>
//                           <div className="col-md-4 mb-3">
//                             <label className="form-label">Process Type</label>
//                             <select className="form-select" value={data.processingType} onChange={(e) => setData({ ...data, processingType: e.target.value })}>
//                               <option value="ONLINE">ONLINE</option>
//                               <option value="OFFLINE">OFFLINE</option>
//                               <option value="VISAONARRIVAL">VISA ON ARRIVAL</option>
//                               <option value="VISANOTREQUIRED">VISA NOT REQUIRED</option>
//                               <option value="OTHERS">OTHERS</option>
//                             </select>
//                           </div>
//                           <div className="col-md-6 mb-3">
//                             <label className="form-label">Flag Code</label>
//                             <input className="form-control" value={data.flagSrc || ""} onChange={(e) => setData({ ...data, flagSrc: e.target.value })} />
//                           </div>
//                           <div className="col-md-6 mb-3">
//                             <label className="form-label">Min Proc. Time (Days)</label>
//                             <input type="number" className="form-control" value={data.lowestProcessingTime || ""} onChange={(e) => setData({ ...data, lowestProcessingTime: e.target.value })} />
//                           </div>
//                         </div>

//                         {/* STATUS TOGGLES */}
//                         <div className="row mt-3 p-3 bg-light rounded border mx-0">
//                           <div className="col-md-3 d-flex align-items-center border-end">
//                             <span className="fw-medium me-2">Active Status:</span>
//                             <div className="form-check form-switch form-switch-md">
//                               <input type="checkbox" className="form-check-input" checked={data.isActive} onChange={(e) => setData({ ...data, isActive: e.target.checked })} />
//                             </div>
//                           </div>
//                           <div className="col-md-3 d-flex align-items-center border-end ms-2">
//                             <span className="fw-medium me-2">B2C Status:</span>
//                             <div className="form-check form-switch form-switch-md">
//                               <input type="checkbox" className="form-check-input" checked={data.b2CStatus} onChange={(e) => setData({ ...data, b2CStatus: e.target.checked })} />
//                             </div>
//                           </div>
//                           <div className="col-md-3 d-flex align-items-center border-end ms-2">
//                             <span className="fw-medium me-2">B2B Status:</span>
//                             <div className="form-check form-switch form-switch-md">
//                               <input type="checkbox" className="form-check-input" checked={data.b2BStatus} onChange={(e) => setData({ ...data, b2BStatus: e.target.checked })} />
//                             </div>
//                           </div>
//                           <div className="col-md-2 d-flex align-items-center ms-2">
//                             <span className="fw-medium me-2">API Status:</span>
//                             <div className="form-check form-switch form-switch-md">
//                               <input type="checkbox" className="form-check-input" checked={data.apiStatus} onChange={(e) => setData({ ...data, apiStatus: e.target.checked })} />
//                             </div>
//                           </div>
//                         </div>
//                       </Tab>

//                       {/* 2. VISAS LIST */}
//                       <Tab eventKey="visas" title={`Visas (${data.visas?.length || 0})`}>
//                         <div className="d-flex justify-content-between align-items-center mt-3">
//                           <h5 className="mb-0">Visa Entry List</h5>
//                           <button className="btn btn-primary btn-sm" onClick={handleAddVisa}>
//                             <i className="ri-add-line align-bottom me-1"></i> Add Visa
//                           </button>
//                         </div>
//                         <div className="table-responsive mt-2" style={{ maxHeight: '600px' }}>
//                           <table className="table table-bordered align-middle table-nowrap">
//                             <thead className="table-light sticky-top">
//                               <tr>
//                                 <th style={{ minWidth: '350px' }}>Visa Name</th>
//                                 <th style={{ minWidth: '120px' }}>Type</th>
//                                 <th style={{ width: '80px' }}>Proc. Time</th>
//                                 <th style={{ minWidth: '120px' }}>Stay Period</th>
//                                 <th style={{ minWidth: '120px' }}>Validity</th>
//                                 <th style={{ minWidth: '120px' }}>Entry</th>
//                                 <th className="text-center">B2B Pricing</th> 
//                                 <th className="text-center">B2C Pricing</th>
//                                 <th>API</th>
//                                 <th>Active</th>
//                                 <th className="text-center">Action</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {data.visas?.map((visa, idx) => (
//                                 <tr key={idx}>
//                                   <td>
//                                     <input className="form-control form-control-sm" value={visa.visaName || ""} onChange={(e) => {
//                                       const newVisas = [...data.visas];
//                                       newVisas[idx].visaName = e.target.value;
//                                       setData({ ...data, visas: newVisas });
//                                     }} />
//                                   </td>
//                                   <td>
//                                     <select className="form-select form-select-sm" value={visa.visaType} onChange={(e) => {
//                                       const newVisas = [...data.visas];
//                                       newVisas[idx].visaType = e.target.value;
//                                       setData({ ...data, visas: newVisas });
//                                     }}>
//                                       <option value="TOURIST">TOURIST</option>
//                                       <option value="BUSINESS">BUSINESS</option>
//                                       <option value="TRANSIT">TRANSIT</option>
//                                     </select>
//                                   </td>
//                                   <td>
//                                     <input type="number" style={{ width: '70px' }} className="form-control form-control-sm mx-auto" value={visa.processingTime} onChange={(e) => {
//                                       const newVisas = [...data.visas];
//                                       newVisas[idx].processingTime = e.target.value;
//                                       setData({ ...data, visas: newVisas });
//                                     }} />
//                                   </td>
//                                   <td><input className="form-control form-control-sm" value={visa.stayPeriod || ""} onChange={(e) => {
//                                     const newVisas = [...data.visas];
//                                     newVisas[idx].stayPeriod = e.target.value;
//                                     setData({ ...data, visas: newVisas });
//                                   }} /></td>
//                                   <td><input className="form-control form-control-sm" value={visa.validity || ""} onChange={(e) => {
//                                     const newVisas = [...data.visas];
//                                     newVisas[idx].validity = e.target.value;
//                                     setData({ ...data, visas: newVisas });
//                                   }} /></td>
//                                   <td>
//                                     <select className="form-select form-select-sm" value={visa.entry} onChange={(e) => {
//                                       const newVisas = [...data.visas];
//                                       newVisas[idx].entry = e.target.value;
//                                       setData({ ...data, visas: newVisas });
//                                     }}>
//                                       <option value="SINGLE">SINGLE</option>
//                                       <option value="MULTIPLE">MULTIPLE</option>
//                                       <option value="DOUBLE">DOUBLE</option>
//                                     </select>
//                                   </td>

//                                   {/* B2B PRICING MODAL BUTTON */}
//                                   <td className="text-center">
//                                     <div className="d-flex align-items-center justify-content-center gap-2">
//                                         <input type="checkbox" className="form-check-input" checked={visa.b2BStatus} onChange={(e) => {
//                                             const newVisas = [...data.visas];
//                                             newVisas[idx].b2BStatus = e.target.checked;
//                                             setData({ ...data, visas: newVisas });
//                                         }} />
//                                         <button className="btn btn-sm btn-soft-primary" onClick={() => handleOpenPriceModal(idx, "B2B")}>
//                                             <i className="ri-money-dollar-circle-line"></i>
//                                         </button>
//                                     </div>
//                                   </td>

//                                   {/* B2C PRICING MODAL BUTTON */}
//                                   <td className="text-center">
//                                     <div className="d-flex align-items-center justify-content-center gap-2">
//                                         <input type="checkbox" className="form-check-input" checked={visa.b2CStatus} onChange={(e) => {
//                                             const newVisas = [...data.visas];
//                                             newVisas[idx].b2CStatus = e.target.checked;
//                                             setData({ ...data, visas: newVisas });
//                                         }} />
//                                         <button className="btn btn-sm btn-soft-info" onClick={() => handleOpenPriceModal(idx, "B2C")}>
//                                             <i className="ri-money-dollar-circle-line"></i>
//                                         </button>
//                                     </div>
//                                   </td>

//                                   <td><input type="checkbox" className="form-check-input" checked={visa.apiStatus} onChange={(e) => {
//                                     const newVisas = [...data.visas];
//                                     newVisas[idx].apiStatus = e.target.checked;
//                                     setData({ ...data, visas: newVisas });
//                                   }} /></td>
//                                   <td><input type="checkbox" className="form-check-input" checked={visa.isActive} onChange={(e) => {
//                                     const newVisas = [...data.visas];
//                                     newVisas[idx].isActive = e.target.checked;
//                                     setData({ ...data, visas: newVisas });
//                                   }} /></td>
//                                   <td className="text-center">
//                                     <button className="btn btn-danger btn-sm" onClick={() => removeVisa(idx)}>
//                                       <i className="ri-delete-bin-line"></i>
//                                     </button>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </Tab>

//                       {/* 3. DOCUMENTS */}
//                       <Tab eventKey="docs" title={`Documents (${data.visaDocuments?.length || 0})`}>
//                         <div className="d-flex justify-content-between align-items-center mt-3">
//                           <h5 className="mb-0">Required Documents</h5>
//                           <button className="btn btn-primary btn-sm" onClick={handleAddDocument}>
//                             <i className="ri-add-line align-bottom me-1"></i> Add Document
//                           </button>
//                         </div>
//                         <div className="table-responsive mt-2">
//                           <table className="table table-bordered align-middle">
//                             <thead className="table-light">
//                               <tr>
//                                 <th style={{ width: '60px' }}>#</th>
//                                 <th style={{ width: '200px' }}>Visa Type</th>
//                                 <th>Document Name / Instructions</th>
//                                 <th style={{ width: '100px' }} className="text-center">Action</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {data.visaDocuments?.map((doc, idx) => (
//                                 <tr key={idx}>
//                                   <td className="text-center font-weight-bold">{idx + 1}</td>
//                                   <td>
//                                     <select className="form-select form-select-sm" value={doc.visaType} onChange={(e) => {
//                                       const newDocs = [...data.visaDocuments];
//                                       newDocs[idx].visaType = e.target.value;
//                                       setData({ ...data, visaDocuments: newDocs });
//                                     }}>
//                                       <option value="TOURIST">TOURIST</option>
//                                       <option value="BUSINESS">BUSINESS</option>
//                                       <option value="TRANSIT">TRANSIT</option>
//                                     </select>
//                                   </td>
//                                   <td>
//                                     <input className="form-control form-control-sm" value={doc.documentName || ""} placeholder="Enter document requirement..." onChange={(e) => {
//                                       const newDocs = [...data.visaDocuments];
//                                       newDocs[idx].documentName = e.target.value;
//                                       setData({ ...data, visaDocuments: newDocs });
//                                     }} />
//                                   </td>
//                                   <td className="text-center">
//                                     <button className="btn btn-danger btn-sm" onClick={() => removeDocument(idx)}>
//                                       <i className="ri-delete-bin-line"></i>
//                                     </button>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </Tab>

//                       {/* 4. TERMS */}
//                       <Tab eventKey="terms" title={`Terms (${data.visaTerms?.length || 0})`}>
//                         <div className="d-flex justify-content-between align-items-center mt-3">
//                           <h5 className="mb-0">Terms & Conditions</h5>
//                           <button className="btn btn-primary btn-sm" onClick={handleAddTerm}>
//                             <i className="ri-add-line align-bottom me-1"></i> Add Term
//                           </button>
//                         </div>
//                         <div className="mt-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
//                           {data.visaTerms?.map((term, idx) => (
//                             <div key={idx} className="card border p-3 mb-2 shadow-sm bg-white position-relative">
//                               <div className="position-absolute top-0 end-0 p-2">
//                                 <button className="btn btn-soft-danger btn-sm" onClick={() => removeTerm(idx)}>
//                                   <i className="ri-delete-bin-line"></i>
//                                 </button>
//                               </div>
//                               <label className="form-label fw-bold">Term {idx + 1}</label>
//                               <textarea
//                                 className="form-control"
//                                 rows="2"
//                                 value={term.termsandConditions || ""}
//                                 placeholder="Enter term and condition text..."
//                                 onChange={(e) => {
//                                   const newTerms = [...data.visaTerms];
//                                   newTerms[idx].termsandConditions = e.target.value;
//                                   setData({ ...data, visaTerms: newTerms });
//                                 }}
//                               ></textarea>
//                             </div>
//                           ))}
//                         </div>
//                       </Tab>

//                       {/* 5. FAQs */}
//                       <Tab eventKey="faqs" title={`FAQs (${data.visaFAQs?.length || 0})`}>
//                         <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
//                           <h5 className="mb-0">Frequently Asked Questions</h5>
//                           <button className="btn btn-primary btn-sm" onClick={handleAddFAQ}>
//                             <i className="ri-add-line align-bottom me-1"></i> Add FAQ
//                           </button>
//                         </div>
//                         <div className="mt-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
//                           {data.visaFAQs?.map((faq, idx) => (
//                             <div key={idx} className="card border p-3 mb-3 shadow-sm bg-white position-relative">
//                               <div className="position-absolute top-0 end-0 p-2">
//                                 <button className="btn btn-soft-danger btn-sm" onClick={() => removeFAQ(idx)}>
//                                   <i className="ri-delete-bin-line"></i>
//                                 </button>
//                               </div>
//                               <div className="row g-3">
//                                 <div className="col-12">
//                                   <label className="form-label fw-bold text-primary">Question {idx + 1}</label>
//                                   <input
//                                     className="form-control"
//                                     value={faq.question || ""}
//                                     placeholder="Enter question here..."
//                                     onChange={(e) => {
//                                       const newFAQs = [...data.visaFAQs];
//                                       newFAQs[idx].question = e.target.value;
//                                       setData({ ...data, visaFAQs: newFAQs });
//                                     }}
//                                   />
//                                 </div>
//                                 <div className="col-12">
//                                   <label className="form-label fw-bold text-success">Answer</label>
//                                   <textarea
//                                     className="form-control"
//                                     rows="3"
//                                     value={faq.answer || ""}
//                                     placeholder="Enter answer here..."
//                                     onChange={(e) => {
//                                       const newFAQs = [...data.visaFAQs];
//                                       newFAQs[idx].answer = e.target.value;
//                                       setData({ ...data, visaFAQs: newFAQs });
//                                     }}
//                                   ></textarea>
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </Tab>
//                     </Tabs>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* --- PRICING MODAL POPUP (Per Visa row) --- */}
//         <Modal show={showPriceModal} onHide={() => setShowPriceModal(false)} centered>
//           <Modal.Header closeButton className="bg-light">
//             <Modal.Title>
//               {priceCategory} Pricing - {activeVisaIdx !== null && data.visas[activeVisaIdx]?.visaName}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {activeVisaIdx !== null && (
//               <div className="row">
//                 <div className="col-lg-12 mb-3 text-center">
//                     <span className={`badge ${priceCategory === 'B2B' ? 'bg-primary' : 'bg-info'} fs-14 p-2`}>
//                         Managing {priceCategory} Rates for this specific Visa
//                     </span>
//                 </div>
//                 <div className="col-lg-12 mb-3">
//                   <label className="form-label">Adult Price</label>
//                   <div className="input-group">
//                     <span className="input-group-text">₹</span>
//                     <input 
//                         type="number" 
//                         className="form-control" 
//                         value={data.visas[activeVisaIdx].visaPrices?.find(p => p.priceType === priceCategory)?.adultPrice || 0} 
//                         onChange={(e) => handlePriceChange("adultPrice", e.target.value)}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-lg-12 mb-3">
//                   <label className="form-label">Child Price</label>
//                   <div className="input-group">
//                     <span className="input-group-text">₹</span>
//                     <input 
//                         type="number" 
//                         className="form-control" 
//                         value={data.visas[activeVisaIdx].visaPrices?.find(p => p.priceType === priceCategory)?.childPrice || 0} 
//                         onChange={(e) => handlePriceChange("childPrice", e.target.value)}
//                     />
//                   </div>
//                 </div>
//                 <div className="col-lg-12 mb-3">
//                   <label className="form-label">Service Fee</label>
//                   <div className="input-group">
//                     <span className="input-group-text">₹</span>
//                     <input 
//                         type="number" 
//                         className="form-control" 
//                         value={data.visas[activeVisaIdx].visaPrices?.find(p => p.priceType === priceCategory)?.serviceFee || 0} 
//                         onChange={(e) => handlePriceChange("serviceFee", e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <button className="btn btn-primary w-100" onClick={() => setShowPriceModal(false)}>Save Pricing</button>
//           </Modal.Footer>
//         </Modal>

//       </div>
//     </div>
//   );
// };

// export default VisaMasterDetails;



import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Modal from 'react-bootstrap/Modal';

const VisaMasterDetails = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- VALIDATION STATE ---
  const [errors, setErrors] = useState({});

  // --- POPUP STATE FOR PRICING ---
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [activeVisaIdx, setActiveVisaIdx] = useState(null);
  const [priceCategory, setPriceCategory] = useState(""); // "B2B" or "B2C"

  useEffect(() => {
    const fetchDetails = async () => {
      const res = await apiService.get(`${config.GET_VISA_BY_ID}/${id}`);
      setData(res);
      setLoading(false);
    };
    fetchDetails();
  }, [id]);

  // --- VALIDATION LOGIC ---
  const validateForm = () => {
    let newErrors = {};

    // General Info Validation
    if (!data.name?.trim()) newErrors.name = "Please enter country name.";
    //if (!data.countryUrl?.trim()) newErrors.countryUrl = "Please enter country URL.";
    if (!data.flagSrc?.trim()) newErrors.flagSrc = "Please enter flag code.";
    if (!data.lowestProcessingTime) newErrors.lowestProcessingTime = "Please enter min processing time.";

    // Visas Validation
    if (data.visas && data.visas.length > 0) {
      const visaErrors = data.visas.map((v) => {
        let error = {};
        if (!v.visaName?.trim()) error.visaName = "Visa name is required.";
        if (!v.stayPeriod?.trim()) error.stayPeriod = "Stay period is required.";
        if (!v.validity?.trim()) error.validity = "Validity is required.";
        if (!v.processingTime) error.processingTime = "Required.";
        return Object.keys(error).length > 0 ? error : null;
      });
      if (visaErrors.some(e => e !== null)) newErrors.visas = visaErrors;
    }

    // Documents Validation
    if (data.visaDocuments && data.visaDocuments.length > 0) {
      const docErrors = data.visaDocuments.map((doc) => {
        if (!doc.documentName?.trim()) return { documentName: "Document name/instruction is required." };
        return null;
      });
      if (docErrors.some(e => e !== null)) newErrors.visaDocuments = docErrors;
    }

    // Terms Validation
    if (data.visaTerms && data.visaTerms.length > 0) {
      const termErrors = data.visaTerms.map((term) => {
        if (!term.termsandConditions?.trim()) return { termsandConditions: "Terms text is required." };
        return null;
      });
      if (termErrors.some(e => e !== null)) newErrors.visaTerms = termErrors;
    }

    // FAQ Validation
    if (data.visaFAQs && data.visaFAQs.length > 0) {
      const faqErrors = data.visaFAQs.map((faq) => {
        let error = {};
        if (!faq.question?.trim()) error.question = "Question is required.";
        if (!faq.answer?.trim()) error.answer = "Answer is required.";
        return Object.keys(error).length > 0 ? error : null;
      });
      if (faqErrors.some(e => e !== null)) newErrors.visaFAQs = faqErrors;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) {
        // Find which section has errors to notify user
        alert("Please fill all required fields marked in red.");
        return;
    }
    const res = await apiService.update(config.UPDATE_VISA_MASTER, data);
    if (res) alert("Data Updated Successfully!");
  };

  // Helper to clear error when user types
  const clearError = (field, index = null, nestedField = null) => {
    let newErrors = { ...errors };
    if (index !== null && nestedField !== null) {
        if (newErrors[field] && newErrors[field][index]) {
            delete newErrors[field][index][nestedField];
        }
    } else {
        delete newErrors[field];
    }
    setErrors(newErrors);
  };

  // --- VISAS LOGIC ---
  const handleAddVisa = () => {
    const newVisa = {
      visaId: "00000000-0000-0000-0000-000000000000",
      visaName: "",
      visaUrl: "",
      countryUrl: data.countryUrl,
      visaType: "TOURIST",
      processingTime: 5,
      stayPeriod: "",
      validity: "",
      entry: "SINGLE",
      visaCountryId: data.visaCountryId,
      visaCountryName: data.name,
      visaPrices: [
        { adultPrice: 0, childPrice: 0, serviceFee: 0, priceType: "B2B" },
        { adultPrice: 0, childPrice: 0, serviceFee: 0, priceType: "B2C" }
      ],
      isActive: true,
      b2CStatus: false,
      b2BStatus: true,
      apiStatus: false
    };
    setData({ ...data, visas: [newVisa, ...data.visas] });
  };

  const removeVisa = (index) => {
    const newVisas = [...data.visas];
    newVisas.splice(index, 1);
    setData({ ...data, visas: newVisas });
  };

  // --- PRICE POPUP LOGIC ---
  const handleOpenPriceModal = (index, category) => {
    const visa = data.visas[index];
    if (!visa.visaPrices) visa.visaPrices = [];
    if (!visa.visaPrices.find(p => p.priceType === category)) {
        visa.visaPrices.push({ adultPrice: 0, childPrice: 0, serviceFee: 0, priceType: category });
    }
    setActiveVisaIdx(index);
    setPriceCategory(category);
    setShowPriceModal(true);
  };

  const handlePriceChange = (field, value) => {
    const newVisas = [...data.visas];
    const visa = newVisas[activeVisaIdx];
    const priceObj = visa.visaPrices.find(p => p.priceType === priceCategory);
    if (priceObj) {
        priceObj[field] = parseFloat(value) || 0;
        setData({ ...data, visas: newVisas });
    }
  };

  // --- DOCUMENTS LOGIC ---
  const handleAddDocument = () => {
    const newDoc = {
      visaDocumentId: null,
      visaCountryId: data.visaCountryId,
      visaType: "TOURIST",
      documentName: "",
      visaCountryName: data.name
    };
    setData({ ...data, visaDocuments: [...data.visaDocuments, newDoc] });
  };

  const removeDocument = (index) => {
    const newDocs = [...data.visaDocuments];
    newDocs.splice(index, 1);
    setData({ ...data, visaDocuments: newDocs });
  };

  // --- TERMS LOGIC ---
  const handleAddTerm = () => {
    const newTerm = {
      visaTermsId: null,
      visaCountryId: data.visaCountryId,
      termsandConditions: "",
      visaCountryName: data.name
    };
    setData({ ...data, visaTerms: [...data.visaTerms, newTerm] });
  };

  const removeTerm = (index) => {
    const newTerms = [...data.visaTerms];
    newTerms.splice(index, 1);
    setData({ ...data, visaTerms: newTerms });
  };

  // --- FAQ LOGIC ---
  const handleAddFAQ = () => {
    const newFAQ = {
      visaFAQId: null,
      visaCountryId: data.visaCountryId,
      question: "",
      answer: "",
      visaCountryName: data.name
    };
    setData({ ...data, visaFAQs: [newFAQ, ...data.visaFAQs] });
  };

  const removeFAQ = (index) => {
    const newFAQs = [...data.visaFAQs];
    newFAQs.splice(index, 1);
    setData({ ...data, visaFAQs: newFAQs });
  };

  if (loading) return <div className="p-5 text-center"><h4>Loading Visa Details...</h4></div>;

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="card-title mb-0">Manage {data.name}</h4>
                    <button className="btn btn-success" onClick={handleUpdate}>
                      <i className="ri-save-line align-bottom me-1"></i> Save Changes
                    </button>
                  </div>
                  <div className="card-body">
                    <Tabs defaultActiveKey="general" className="nav-tabs-custom">

                      {/* 1. GENERAL INFO */}
                      <Tab eventKey="general" title="General Info">
                        <div className="row mt-4">
                          <div className="col-md-4 mb-3">
                            <label className="form-label">Country Name</label>
                            <input 
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`} 
                                value={data.name || ""} 
                                onChange={(e) => {
                                    setData({ ...data, name: e.target.value });
                                    clearError('name');
                                }} 
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                          </div>
                          {/* <div className="col-md-4 mb-3">
                            <label className="form-label">Country URL</label>
                            <input 
                                className={`form-control ${errors.countryUrl ? 'is-invalid' : ''}`} 
                                value={data.countryUrl || ""} 
                                onChange={(e) => {
                                    setData({ ...data, countryUrl: e.target.value });
                                    clearError('countryUrl');
                                }} 
                            />
                            {errors.countryUrl && <div className="invalid-feedback">{errors.countryUrl}</div>}
                          </div> */}
                          <div className="col-md-4 mb-3">
                            <label className="form-label">Process Type</label>
                            <select className="form-select" value={data.processingType} onChange={(e) => setData({ ...data, processingType: e.target.value })}>
                              <option value="ONLINE">ONLINE</option>
                              <option value="OFFLINE">OFFLINE</option>
                              <option value="VISAONARRIVAL">VISA ON ARRIVAL</option>
                              <option value="VISANOTREQUIRED">VISA NOT REQUIRED</option>
                              <option value="OTHERS">OTHERS</option>
                            </select>
                          </div>
                          <div className="col-md-2 mb-3">
                            <label className="form-label">Flag Code</label>
                            <input 
                                className={`form-control ${errors.flagSrc ? 'is-invalid' : ''}`} 
                                value={data.flagSrc || ""} 
                                onChange={(e) => {
                                    setData({ ...data, flagSrc: e.target.value });
                                    clearError('flagSrc');
                                }} 
                            />
                            {errors.flagSrc && <div className="invalid-feedback">{errors.flagSrc}</div>}
                          </div>
                          <div className="col-md-2 mb-3">
                            <label className="form-label">Min Proc. Time (Days)</label>
                            <input 
                                type="number" 
                                className={`form-control ${errors.lowestProcessingTime ? 'is-invalid' : ''}`} 
                                value={data.lowestProcessingTime || ""} 
                                onChange={(e) => {
                                    setData({ ...data, lowestProcessingTime: e.target.value });
                                    clearError('lowestProcessingTime');
                                }} 
                            />
                            {errors.lowestProcessingTime && <div className="invalid-feedback">{errors.lowestProcessingTime}</div>}
                          </div>
                        </div>

                        {/* STATUS TOGGLES */}
                        <div className="row mt-3 p-3 bg-light rounded border mx-0">
                          <div className="col-md-3 d-flex align-items-center border-end">
                            <span className="fw-medium me-2">Active Status:</span>
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" className="form-check-input" checked={data.isActive} onChange={(e) => setData({ ...data, isActive: e.target.checked })} />
                            </div>
                          </div>
                          <div className="col-md-3 d-flex align-items-center border-end ms-2">
                            <span className="fw-medium me-2">B2C Status:</span>
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" className="form-check-input" checked={data.b2CStatus} onChange={(e) => setData({ ...data, b2CStatus: e.target.checked })} />
                            </div>
                          </div>
                          <div className="col-md-3 d-flex align-items-center border-end ms-2">
                            <span className="fw-medium me-2">B2B Status:</span>
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" className="form-check-input" checked={data.b2BStatus} onChange={(e) => setData({ ...data, b2BStatus: e.target.checked })} />
                            </div>
                          </div>
                          <div className="col-md-2 d-flex align-items-center ms-2">
                            <span className="fw-medium me-2">API Status:</span>
                            <div className="form-check form-switch form-switch-md">
                              <input type="checkbox" className="form-check-input" checked={data.apiStatus} onChange={(e) => setData({ ...data, apiStatus: e.target.checked })} />
                            </div>
                          </div>
                        </div>
                      </Tab>

                      {/* 2. VISAS LIST */}
                      <Tab eventKey="visas" title={`Visas (${data.visas?.length || 0})`}>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <h5 className="mb-0">Visa Entry List</h5>
                          <button className="btn btn-primary btn-sm" onClick={handleAddVisa}>
                            <i className="ri-add-line align-bottom me-1"></i> Add Visa
                          </button>
                        </div>
                        <div className="table-responsive mt-2" style={{ maxHeight: '600px' }}>
                          <table className="table table-bordered align-middle table-nowrap">
                            <thead className="table-light sticky-top">
                              <tr>
                                <th style={{ minWidth: '350px' }}>Visa Name</th>
                                <th style={{ minWidth: '120px' }}>Type</th>
                                <th style={{ width: '80px' }}>Proc. Time</th>
                                <th style={{ minWidth: '120px' }}>Stay Period</th>
                                <th style={{ minWidth: '120px' }}>Validity</th>
                                <th style={{ minWidth: '120px' }}>Entry</th>
                                <th className="text-center">B2B Pricing</th> 
                                <th className="text-center">B2C Pricing</th>
                                <th>API</th>
                                <th>Active</th>
                                <th className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.visas?.map((visa, idx) => (
                                <tr key={idx}>
                                  <td>
                                    <input 
                                        className={`form-control form-control-sm ${errors.visas?.[idx]?.visaName ? 'is-invalid' : ''}`} 
                                        value={visa.visaName || ""} 
                                        onChange={(e) => {
                                            const newVisas = [...data.visas];
                                            newVisas[idx].visaName = e.target.value;
                                            setData({ ...data, visas: newVisas });
                                            clearError('visas', idx, 'visaName');
                                        }} 
                                    />
                                    {errors.visas?.[idx]?.visaName && <div className="text-danger fs-11 mt-1">{errors.visas[idx].visaName}</div>}
                                  </td>
                                  <td>
                                    <select className="form-select form-select-sm" value={visa.visaType} onChange={(e) => {
                                      const newVisas = [...data.visas];
                                      newVisas[idx].visaType = e.target.value;
                                      setData({ ...data, visas: newVisas });
                                    }}>
                                      <option value="TOURIST">TOURIST</option>
                                      <option value="BUSINESS">BUSINESS</option>
                                      <option value="TRANSIT">TRANSIT</option>
                                    </select>
                                  </td>
                                  <td>
                                    <input 
                                        type="number" 
                                        style={{ width: '70px' }} 
                                        className={`form-control form-control-sm mx-auto ${errors.visas?.[idx]?.processingTime ? 'is-invalid' : ''}`} 
                                        value={visa.processingTime} 
                                        onChange={(e) => {
                                            const newVisas = [...data.visas];
                                            newVisas[idx].processingTime = e.target.value;
                                            setData({ ...data, visas: newVisas });
                                            clearError('visas', idx, 'processingTime');
                                        }} 
                                    />
                                  </td>
                                  <td>
                                    <input 
                                        className={`form-control form-control-sm ${errors.visas?.[idx]?.stayPeriod ? 'is-invalid' : ''}`} 
                                        value={visa.stayPeriod || ""} 
                                        onChange={(e) => {
                                            const newVisas = [...data.visas];
                                            newVisas[idx].stayPeriod = e.target.value;
                                            setData({ ...data, visas: newVisas });
                                            clearError('visas', idx, 'stayPeriod');
                                        }} 
                                    />
                                    {errors.visas?.[idx]?.stayPeriod && <div className="text-danger fs-11 mt-1">{errors.visas[idx].stayPeriod}</div>}
                                  </td>
                                  <td>
                                    <input 
                                        className={`form-control form-control-sm ${errors.visas?.[idx]?.validity ? 'is-invalid' : ''}`} 
                                        value={visa.validity || ""} 
                                        onChange={(e) => {
                                            const newVisas = [...data.visas];
                                            newVisas[idx].validity = e.target.value;
                                            setData({ ...data, visas: newVisas });
                                            clearError('visas', idx, 'validity');
                                        }} 
                                    />
                                    {errors.visas?.[idx]?.validity && <div className="text-danger fs-11 mt-1">{errors.visas[idx].validity}</div>}
                                  </td>
                                  <td>
                                    <select className="form-select form-select-sm" value={visa.entry} onChange={(e) => {
                                      const newVisas = [...data.visas];
                                      newVisas[idx].entry = e.target.value;
                                      setData({ ...data, visas: newVisas });
                                    }}>
                                      <option value="SINGLE">SINGLE</option>
                                      <option value="MULTIPLE">MULTIPLE</option>
                                      <option value="DOUBLE">DOUBLE</option>
                                    </select>
                                  </td>

                                  <td className="text-center">
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <input type="checkbox" className="form-check-input" checked={visa.b2BStatus} onChange={(e) => {
                                            const newVisas = [...data.visas];
                                            newVisas[idx].b2BStatus = e.target.checked;
                                            setData({ ...data, visas: newVisas });
                                        }} />
                                        <button className="btn btn-sm btn-soft-primary" onClick={() => handleOpenPriceModal(idx, "B2B")}>
                                            <i className="ri-money-dollar-circle-line"></i>
                                        </button>
                                    </div>
                                  </td>

                                  <td className="text-center">
                                    <div className="d-flex align-items-center justify-content-center gap-2">
                                        <input type="checkbox" className="form-check-input" checked={visa.b2CStatus} onChange={(e) => {
                                            const newVisas = [...data.visas];
                                            newVisas[idx].b2CStatus = e.target.checked;
                                            setData({ ...data, visas: newVisas });
                                        }} />
                                        <button className="btn btn-sm btn-soft-info" onClick={() => handleOpenPriceModal(idx, "B2C")}>
                                            <i className="ri-money-dollar-circle-line"></i>
                                        </button>
                                    </div>
                                  </td>

                                  <td><input type="checkbox" className="form-check-input" checked={visa.apiStatus} onChange={(e) => {
                                    const newVisas = [...data.visas];
                                    newVisas[idx].apiStatus = e.target.checked;
                                    setData({ ...data, visas: newVisas });
                                  }} /></td>
                                  <td><input type="checkbox" className="form-check-input" checked={visa.isActive} onChange={(e) => {
                                    const newVisas = [...data.visas];
                                    newVisas[idx].isActive = e.target.checked;
                                    setData({ ...data, visas: newVisas });
                                  }} /></td>
                                  <td className="text-center">
                                    <button className="btn btn-danger btn-sm" onClick={() => removeVisa(idx)}>
                                      <i className="ri-delete-bin-line"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Tab>

                      {/* 3. DOCUMENTS */}
                      <Tab eventKey="docs" title={`Documents (${data.visaDocuments?.length || 0})`}>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <h5 className="mb-0">Required Documents</h5>
                          <button className="btn btn-primary btn-sm" onClick={handleAddDocument}>
                            <i className="ri-add-line align-bottom me-1"></i> Add Document
                          </button>
                        </div>
                        <div className="table-responsive mt-2">
                          <table className="table table-bordered align-middle">
                            <thead className="table-light">
                              <tr>
                                <th style={{ width: '60px' }}>#</th>
                                <th style={{ width: '200px' }}>Visa Type</th>
                                <th>Document Name / Instructions</th>
                                <th style={{ width: '100px' }} className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.visaDocuments?.map((doc, idx) => (
                                <tr key={idx}>
                                  <td className="text-center font-weight-bold">{idx + 1}</td>
                                  <td>
                                    <select className="form-select form-select-sm" value={doc.visaType} onChange={(e) => {
                                      const newDocs = [...data.visaDocuments];
                                      newDocs[idx].visaType = e.target.value;
                                      setData({ ...data, visaDocuments: newDocs });
                                    }}>
                                      <option value="TOURIST">TOURIST</option>
                                      <option value="BUSINESS">BUSINESS</option>
                                      <option value="TRANSIT">TRANSIT</option>
                                    </select>
                                  </td>
                                  <td>
                                    <input 
                                        className={`form-control form-control-sm ${errors.visaDocuments?.[idx]?.documentName ? 'is-invalid' : ''}`} 
                                        value={doc.documentName || ""} 
                                        placeholder="Enter document requirement..." 
                                        onChange={(e) => {
                                            const newDocs = [...data.visaDocuments];
                                            newDocs[idx].documentName = e.target.value;
                                            setData({ ...data, visaDocuments: newDocs });
                                            clearError('visaDocuments', idx, 'documentName');
                                        }} 
                                    />
                                    {errors.visaDocuments?.[idx]?.documentName && <div className="text-danger fs-11 mt-1">{errors.visaDocuments[idx].documentName}</div>}
                                  </td>
                                  <td className="text-center">
                                    <button className="btn btn-danger btn-sm" onClick={() => removeDocument(idx)}>
                                      <i className="ri-delete-bin-line"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </Tab>

                      {/* 4. TERMS */}
                      <Tab eventKey="terms" title={`Terms (${data.visaTerms?.length || 0})`}>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <h5 className="mb-0">Terms & Conditions</h5>
                          <button className="btn btn-primary btn-sm" onClick={handleAddTerm}>
                            <i className="ri-add-line align-bottom me-1"></i> Add Term
                          </button>
                        </div>
                        <div className="mt-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                          {data.visaTerms?.map((term, idx) => (
                            <div key={idx} className="card border p-3 mb-2 shadow-sm bg-white position-relative">
                              <div className="position-absolute top-0 end-0 p-2">
                                <button className="btn btn-soft-danger btn-sm" onClick={() => removeTerm(idx)}>
                                  <i className="ri-delete-bin-line"></i>
                                </button>
                              </div>
                              <label className="form-label fw-bold">Term {idx + 1}</label>
                              <textarea
                                className={`form-control ${errors.visaTerms?.[idx]?.termsandConditions ? 'is-invalid' : ''}`}
                                rows="2"
                                value={term.termsandConditions || ""}
                                placeholder="Enter term and condition text..."
                                onChange={(e) => {
                                  const newTerms = [...data.visaTerms];
                                  newTerms[idx].termsandConditions = e.target.value;
                                  setData({ ...data, visaTerms: newTerms });
                                  clearError('visaTerms', idx, 'termsandConditions');
                                }}
                              ></textarea>
                              {errors.visaTerms?.[idx]?.termsandConditions && <div className="text-danger fs-11 mt-1">{errors.visaTerms[idx].termsandConditions}</div>}
                            </div>
                          ))}
                        </div>
                      </Tab>

                      {/* 5. FAQs */}
                      <Tab eventKey="faqs" title={`FAQs (${data.visaFAQs?.length || 0})`}>
                        <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
                          <h5 className="mb-0">Frequently Asked Questions</h5>
                          <button className="btn btn-primary btn-sm" onClick={handleAddFAQ}>
                            <i className="ri-add-line align-bottom me-1"></i> Add FAQ
                          </button>
                        </div>
                        <div className="mt-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                          {data.visaFAQs?.map((faq, idx) => (
                            <div key={idx} className="card border p-3 mb-3 shadow-sm bg-white position-relative">
                              <div className="position-absolute top-0 end-0 p-2">
                                <button className="btn btn-soft-danger btn-sm" onClick={() => removeFAQ(idx)}>
                                  <i className="ri-delete-bin-line"></i>
                                </button>
                              </div>
                              <div className="row g-3">
                                <div className="col-12">
                                  <label className="form-label fw-bold text-primary">Question {idx + 1}</label>
                                  <input
                                    className={`form-control ${errors.visaFAQs?.[idx]?.question ? 'is-invalid' : ''}`}
                                    value={faq.question || ""}
                                    placeholder="Enter question here..."
                                    onChange={(e) => {
                                      const newFAQs = [...data.visaFAQs];
                                      newFAQs[idx].question = e.target.value;
                                      setData({ ...data, visaFAQs: newFAQs });
                                      clearError('visaFAQs', idx, 'question');
                                    }}
                                  />
                                  {errors.visaFAQs?.[idx]?.question && <div className="text-danger fs-11 mt-1">{errors.visaFAQs[idx].question}</div>}
                                </div>
                                <div className="col-12">
                                  <label className="form-label fw-bold text-success">Answer</label>
                                  <textarea
                                    className={`form-control ${errors.visaFAQs?.[idx]?.answer ? 'is-invalid' : ''}`}
                                    rows="3"
                                    value={faq.answer || ""}
                                    placeholder="Enter answer here..."
                                    onChange={(e) => {
                                      const newFAQs = [...data.visaFAQs];
                                      newFAQs[idx].answer = e.target.value;
                                      setData({ ...data, visaFAQs: newFAQs });
                                      clearError('visaFAQs', idx, 'answer');
                                    }}
                                  ></textarea>
                                  {errors.visaFAQs?.[idx]?.answer && <div className="text-danger fs-11 mt-1">{errors.visaFAQs[idx].answer}</div>}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- PRICING MODAL POPUP --- */}
        <Modal show={showPriceModal} onHide={() => setShowPriceModal(false)} centered>
          <Modal.Header closeButton className="bg-light">
            <Modal.Title>
              {priceCategory} Pricing - {activeVisaIdx !== null && data.visas[activeVisaIdx]?.visaName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {activeVisaIdx !== null && (
              <div className="row">
                <div className="col-lg-12 mb-3 text-center">
                    <span className={`badge ${priceCategory === 'B2B' ? 'bg-primary' : 'bg-info'} fs-14 p-2`}>
                        Managing {priceCategory} Rates
                    </span>
                </div>
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Adult Price</label>
                  <div className="input-group">
                    <span className="input-group-text">₹</span>
                    <input 
                        type="number" 
                        className="form-control" 
                        value={data.visas[activeVisaIdx].visaPrices?.find(p => p.priceType === priceCategory)?.adultPrice || 0} 
                        onChange={(e) => handlePriceChange("adultPrice", e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Child Price</label>
                  <div className="input-group">
                    <span className="input-group-text">₹</span>
                    <input 
                        type="number" 
                        className="form-control" 
                        value={data.visas[activeVisaIdx].visaPrices?.find(p => p.priceType === priceCategory)?.childPrice || 0} 
                        onChange={(e) => handlePriceChange("childPrice", e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-12 mb-3">
                  <label className="form-label">Service Fee</label>
                  <div className="input-group">
                    <span className="input-group-text">₹</span>
                    <input 
                        type="number" 
                        className="form-control" 
                        value={data.visas[activeVisaIdx].visaPrices?.find(p => p.priceType === priceCategory)?.serviceFee || 0} 
                        onChange={(e) => handlePriceChange("serviceFee", e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-primary w-100" onClick={() => setShowPriceModal(false)}>Save Pricing</button>
          </Modal.Footer>
        </Modal>

      </div>
    </div>
  );
};

export default VisaMasterDetails;